export const getAltTextFromImage = ({
  src,
  currentAltText,
  fileName
}) => {
  if (src && !currentAltText && fileName) {
    return fileName;
  } else {
    return currentAltText;
  }
};